// extracted by mini-css-extract-plugin
export default {"icon":"no-purify__helkaCardButton__icon___pnGrB"};